// export default class CPOConstants {
// public static readonly EXPECTED_FILES_BY_BLOCK: Record<string, string[]> = {
//   //"Block Name": ["Asset Name that is expecting a file", "Asset name that is expecting another file"]

//   //Block 0 - 6 assets, 1(?) file
//   "0": ["SANHA", "MAFUMEIRA", "AREA B", "TAKULA", "MALONGO", "MALONGO BASE - TERMINAL"], //Need more asset names?
//   //Block FS_FST - 1 asset, 1 file
//   "fs_fst": ["FS_FST"],
//   //Block 2_05 - 1 asset, 1 file
//   "2_05": ["BLOCK 2 PLATFORMS"],
//   //Block 3_05 - 2 asset, 2 files
//   "3_05": ["BLOCK 3_05", "BLOCK 3_05A"],
//   //Block 4 ?
//   "4": [""],
//   //Block 14 - 2 assets, 1 file
//   "14": ["BBLT"], //Need more asset names?
//   //Block 15 - 4 assets, 5 files?
//   "15": ["KIZOMBA A", "KIZOMBA B", "MONDO", "SAXI - BATUGUE", "Summary Report"],
//   //Block 15_06 - 3 assets, 3 files
//   "15_06": ["AGOGO", "OLOMBENDO", "NGOMA"],
//   //Block 17 - 4 assets, 1 file
//   "17": ["CLOV",], //Need more asset names?
//   //Block 17_06 - 1 asset, 1 file
//   "17_06": ["BEGONIA (17_06)",],
//   //Block 18 - 1 asset, 1 file
//   "18": ["Greater Plutonio"],
//   //Block 31 - 1 asset, 1 file
//   "31": ["PSVM"],
//   //Block 32 - 2 assets, 1 file
//   "32": ["KAOMBO NORTH"], //Need more asset names?
//   //Block 32 - 1 asset, 1 file
//   "cabinda_sul": ["CABINDA SUL"],
// };

export interface ExpectedReport {
  reportDisplayName: string;
  expectedAssets: string[];
}

export default class CPOConstants {
  public static readonly EXPECTED_REPORTS_BY_BLOCK: Record<
    string,
    ExpectedReport[]
  > = {
    // Block 0 - 6 assets, 1 file
    "0": [
      {
        reportDisplayName: "Deferrals Report", // Your standard report
        expectedAssets: [
          "SANHA",
          "MAFUMEIRA",
          "AREA B",
          "TAKULA",
          "MALONGO",
          "MALONGO BASE - TERMINAL",
        ],
      },
      {
        reportDisplayName: "Daily Ops", // The new independent file
        expectedAssets: [], // Empty! So it doesn't affect asset fractions
      },
      {
        reportDisplayName: "Production Daily", // The other independent file
        expectedAssets: [],
      },
    ],

    // Block FS_FST - 1 asset, 1 file
    fs_fst: [
      {
        reportDisplayName: "FS_FST",
        expectedAssets: ["FS_FST"],
      },
    ],

    // Block 2_05 - 1 asset, 1 file
    "2_05": [
      {
        reportDisplayName: "BLK2",
        expectedAssets: ["BLOCK 2 PLATFORMS"],
      },
    ],

    // Block 3_05 - 2 assets, 2 files
    "3_05": [
      {
        reportDisplayName: "BLK3-05",
        expectedAssets: ["BLOCK 3_05"],
      },
      {
        reportDisplayName: "BLK3-05A",
        expectedAssets: ["BLOCK 3_05A"],
      },
    ],

    // Block 4 -
    "4": [
      {
        reportDisplayName: "BLK4",
        expectedAssets: [], // TODO: Add Block 4 asset names here when known
      },
    ],

    // Block 14 - 3 assets, 1 file
    "14": [
      {
        reportDisplayName: "Deferrals Report",
        expectedAssets: ["BBLT", "TL", "KUITO"],
      },
      {
        reportDisplayName: "Daily Ops",
        expectedAssets: [],
      },
    ],

    // Block 15 - 4 assets, individual files expected
    "15": [
      {
        reportDisplayName: "KIZOMBA A",
        expectedAssets: ["KIZOMBA A"],
      },
      {
        reportDisplayName: "KIZOMBA B",
        expectedAssets: ["KIZOMBA B"],
      },
      {
        reportDisplayName: "MONDO",
        expectedAssets: ["MONDO"],
      },
      {
        reportDisplayName: "SAXI - BATUQUE",
        expectedAssets: ["SAXI - BATUQUE"],
      },
    ],

    // Block 15_06 - 3 assets, 3 files
    "15_06": [
      {
        reportDisplayName: "AGOGO",
        expectedAssets: ["AGOGO"],
      },
      {
        reportDisplayName: "OLOMBENDO",
        expectedAssets: ["OLOMBENDO"],
      },
      {
        reportDisplayName: "N'GOMA",
        expectedAssets: ["N'GOMA"],
      },
    ],

    // Block 17 - 4 assets, 1 file
    "17": [
      {
        reportDisplayName: "DB17",
        expectedAssets: ["GIRASSOL", "DALIA", "PAZFLOR", "CLOV"],
      },
    ],

    // Block 17_06 - 1 asset, 1 file
    "17_06": [
      {
        reportDisplayName: "DB17.06",
        expectedAssets: ["BEGONIA (17_06)"],
      },
    ],

    // Block 18 - 1 asset, 1 file
    "18": [
      {
        reportDisplayName: "GREATER PLUTONIO",
        expectedAssets: ["GREATER PLUTONIO"],
      },
    ],

    // Block 31 - 1 asset, 1 file
    "31": [
      {
        reportDisplayName: "PSVM",
        expectedAssets: ["PSVM"],
      },
    ],

    // Block 32 - 2 assets, 1 file
    "32": [
      {
        reportDisplayName: "DB32",
        expectedAssets: ["KAOMBO NORTH", "KAOMBO SOUTH"],
      },
    ],

    // Cabinda Sul - 1 asset, 1 file
    cabinda_sul: [
      {
        reportDisplayName: "CASTANHA",
        expectedAssets: ["CABINDA SUL"],
      },
    ],
  };

  // Safe fallback if a block isn't found in the dictionary
  public static readonly DEFAULT_EXPECTED_REPORTS: ExpectedReport[] = [
    {
      reportDisplayName: "Missing Report",
      expectedAssets: [],
    },
  ];
}
